import { Box, Typography } from "@mui/material";
import { FC } from "react";

interface PasswordStrengthBarProps {
  strength: number;
}

const PasswordStrengthBar: FC<PasswordStrengthBarProps> = ({ strength }) => {
  const segments = 5;
  const activeSegments = Math.ceil((strength / 100) * segments);

  return (
    <Box sx={{ width: "100%" }}>
      <Box display="flex" alignItems="center">
        <Box sx={{ flexGrow: 1, display: "flex", gap: "4px" }}>
          {Array.from({ length: segments }).map((_, index) => (
            <Box
              key={index}
              sx={{
                flex: 1,
                height: "8px",
                borderRadius: "4px",
                backgroundColor: index < activeSegments ? "#00c853" : "#e0e0e0",
              }}
            />
          ))}
        </Box>
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{ paddingLeft: "8px" }}
        >
          Strong
        </Typography>
      </Box>
    </Box>
  );
};

export default PasswordStrengthBar;
